export const TXERCohesionConfig = {
  fuse: {
    endpoint: 'https://www.texaselectricrates.com/fuse',
    leases: [
      {
        name: 'ES-TXER-FUSE-PERMA-BANNER',
        pool: 'MfitUsNumeh7eS3jnhYjAe',
      },
      {
        name: 'ES-TXER-FUSE-PERMA-GRID',
        pool: 'MfitUsNumeh7eS3jnhYjAe',
      },
    ],
  },
  monarch: {
    autoRequest: {
      enabled: true,
      suppressPlacements: true,
      timeout: 15000,
    },
    sourceId: '0650c532-2b02-47b9-8702-f7eaee5cb519',
    token: '34024028-8935-4801-b0dc-c87c967c184d',
  },
  tagular: {
    apiHost: 'https://www.texaselectricrates.com/tagular/v2/t',
    apiKey: '80b84897-a06c-4e93-bd90-846793505c5f',
    // beamHook(event: any) {
    //   window.dataLayer = window.dataLayer || []
    //   window.dataLayer.push({
    //     event: event['@type'],
    //     tagularPayload: event,
    //   })
    // },
    cookieDomain: 'texaselectricrates.com',
    domainWhitelist: ['electricrates.texaselectricrates.com'],
    sourceKey: 'src_1NT29nOuRKHkgkN4EttvrqLmjJg',
    writeKey: 'wk_1NT29nRejNcVvhd18B7wJRJ7lpT',
  },
}
